import card53 from './53.jpg';
import card54 from './54.jpg';
import card55 from './55.jpg';
import card56 from './56.jpg';
import card57 from './57.jpg';
import card58 from './58.jpg';
import card59 from './59.jpg';
import card60 from './60.jpg';
import card61 from './61.jpg';
import card62 from './62.jpg';
import card63 from './63.jpg';
import card64 from './64.jpg';
import card65 from './65.jpg';

const cards_data4 = [
    {
        image:card53,
        
    },
    {
        image:card54,
        
    },
    {
        image:card55,
        
    },
    {
        image:card56,
        
    },
    {
        image:card57,
        
    },
    {
        image:card58,
        
    },
    {
        image:card59,
        
    },
    {
        image:card60,
       
    },
    {
        image:card61,
        
    },
    {
        image:card62,
        
    },
    {
        image:card63,
        
    },
    {
        image:card64,
        
    },
    {
        image:card65,
        
    }
]
export default cards_data4;